import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { VennHealthGridResult } from '../models/vennhealth-grid-result';
import { FilterModel, SavedQueriesModel } from '@app/models/filter-model';

@Injectable({
  providedIn: 'root'
})
export class VennHealthDataService {

  constructor(
    private readonly httpClient: HttpClient
  ) { }

  //#region GET

  getUserName(): Observable<string> {
    const request = this.httpClient.get<string>(
      `${environment.tessellonApiBaseUrl}/${environment.vennHealthBaseUrl}/${environment.userNameUrl}/`
    ).pipe(catchError(this.errorHandler));
    return request;
  }

  getClientSavedFilterNamesList(): Observable<Array<SavedQueriesModel>> {
    const request = this.httpClient.get<Array<SavedQueriesModel>>(
      `${environment.tessellonApiBaseUrl}/${environment.vennHealthBaseUrl}/${environment.savedFilterNamesUrl}`
    )
    .pipe(catchError(this.errorHandler));
    return request;
  }

  getSavedFilter(queryId: string): Observable<SavedQueriesModel> {
    const request = this.httpClient
    .get<SavedQueriesModel>(
      `${environment.tessellonApiBaseUrl}/${environment.vennHealthBaseUrl}/${environment.savedFilter}/${queryId}/`)
    .pipe(catchError(this.errorHandler));
    return request;
  }

  getExecutedQueriesList(limit: number = 20): Observable<SavedQueriesModel[]> {
    const request = this.httpClient
    .get<SavedQueriesModel[]>(
      `${environment.tessellonApiBaseUrl}/${environment.vennHealthBaseUrl}/${environment.executedQueriesListUrl}/${limit}`)
    .pipe(catchError(this.errorHandler));
    return request;
  }

  getExecutedQuery(queryId: string): Observable<SavedQueriesModel> {
    const request = this.httpClient
    .get<SavedQueriesModel>(
      `${environment.tessellonApiBaseUrl}/${environment.vennHealthBaseUrl}/${environment.executedQueryUrl}/${queryId}/`)
    .pipe(catchError(this.errorHandler));
    return request;
  }

  //#endregion GET

  //#region POST

  runQuery(filters: FilterModel): Observable<VennHealthGridResult> {
    return this.httpClient
    .post<VennHealthGridResult>(`${environment.tessellonApiBaseUrl}/${environment.vennHealthBaseUrl}/${environment.runQueryUrl}`, filters)
    .pipe(catchError(this.errorHandler));
  }

  logExecutedQueryStart(filters: FilterModel) {
    return this.httpClient
    .post(`${environment.tessellonApiBaseUrl}/${environment.vennHealthBaseUrl}/${environment.logExecutedQueryStartUrl}`, filters)
    .pipe(catchError(this.errorHandler));
  }

  saveFilters(filters: SavedQueriesModel): Observable<any> {
    return this.httpClient
    .post(`${environment.tessellonApiBaseUrl}/${environment.vennHealthBaseUrl}/${environment.saveFiltersUrl}`, filters)
    .pipe(catchError(this.errorHandler));
  }

  renameFilter(filters: any): Observable<any> {
    return this.httpClient
    .post(`${environment.tessellonApiBaseUrl}/${environment.vennHealthBaseUrl}/${environment.renameFilterUrl}`, filters)
    .pipe(catchError(this.errorHandler));
  }

  utrackEvent(filters: any): Observable<any> {
    return this.httpClient
    .post(`${environment.tessellonApiBaseUrl}/${environment.vennHealthBaseUrl}/event`, filters)
    .pipe(catchError(this.errorHandler));
  }

  //#endregion POST

  //#region DELETE (using POST to avoid .NET DELETE mapping issues on MVC and Web API 2)
  //todo update this since we are now on .NET 6 stack

  deleteSavedFilter(queryId: number): Observable<any> {
    const deleteModel = {
      id: queryId
    };
    return this.httpClient.post(
      `${environment.tessellonApiBaseUrl}/${environment.vennHealthBaseUrl}/${environment.deleteSavedFilterUrl}`, deleteModel, {observe: 'response'}
    ).pipe(catchError(this.errorHandler));
  }

  //#endregion DELETE

  private errorHandler(err: HttpErrorResponse) {
    let errorMessage = '';
    if (err.error instanceof ErrorEvent || (err.error && err.error.hasOwnProperty('message'))) {
      errorMessage = `An Error Occurred: ${err.error.message}`;
    } else {
      errorMessage = err.toString();
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
